import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new page
export const createPage = async (pageData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.PAGES.CREATE, pageData);
    return response.data;
  } catch (error) {
    console.error('Error creating page:', error);
    throw error;
  }
};

// Update an existing page
export const updatePage = async (pageId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.PAGES.UPDATE}/${pageId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating page:', error);
    throw error;
  }
};

// Get all pages with optional query parameters
export const getPages = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
      sortBy: queryParams?.sortBy || 'createdAt',
      status: queryParams?.status || ""
    };

    const response = await axiosInstance.get(API_ROUTES.PAGES.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching pages:', error);
    throw error;
  }
};

export const getPage = async (pageId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PAGES.GET_SINGLE_PAGE}/${pageId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching pages:', error);
    throw error;
  }
};

// Delete one or multiple pages
export const deletePages = async (pageIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.PAGES.DELETE, {
      data: {
        ids: pageIds // array of numbers, e.g., [1, 2, 3]
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting pages:', error);
    throw error;
  }
};

const pagesApi = {
  createPage,
  updatePage,
  getPages,
  deletePages,
};

export default pagesApi;